// 解析 omnibus 交易接口请求地址
export default function parseBsTradeRequestUrl(url, isVirtual) {
  if (isVirtual) {
    return `~virtualTrade${url}`
  }
  return `~omnibusTrade${url}`
}
